import { UnitStatusSearchForm } from '@mark43/cad-api';
import { createContext, ReactNode, useContext } from 'react';
import { TabsContextType, useSearchTabs } from '../search-windows/use-search-tabs';

const UnitStatusSearchTabsContext = createContext<
    TabsContextType<UnitStatusSearchForm> | undefined
>(undefined);

export function useUnitStatusSearchTabsContext() {
    const context = useContext(UnitStatusSearchTabsContext);
    if (context === undefined) {
        throw new Error(
            'useUnitStatusSearchTabsContext must be used within a UnitStatusSearchTabsProvider'
        );
    }
    return context;
}

export const UnitStatusSearchTabsProvider = ({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) => {
    const tabsValue = useSearchTabs<UnitStatusSearchForm>(initialTab);
    return (
        <UnitStatusSearchTabsContext.Provider value={tabsValue}>
            {children}
        </UnitStatusSearchTabsContext.Provider>
    );
};
